// Version of the portable profile document format. Bump only for a breaking shape change;
// parseProfileDocument rejects anything it does not recognize, which is deliberate — a file
// from an older admin panel may be missing fields that upload would then erase.
export const FORMAT_VERSION = 1;

export const PROFILE_KINDS = {
  EXPORT: 'exportProfile',
  IMPORT: 'importProfile',
  DATA_TABLE: 'dataTableProfile',
};

// Which identity keys make a target unique, per kind. These mirror the unique indexes on the
// underlying collections, so a target can never resolve to more than one profile.
export const IDENTITY_KEYS = {
  [PROFILE_KINDS.EXPORT]: ['exportType'],
  [PROFILE_KINDS.IMPORT]: ['importType', 'importName'],
  [PROFILE_KINDS.DATA_TABLE]: ['dataTableName'],
};
